import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { ServiceplanFormComponent } from './serviceplan-form.component';
import { ServiceplanFormRoutingModule } from './serviceplan-form-routing.module';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { SignaturePadModule } from 'angular2-signaturepad';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { EventsModule } from '../events/events.module';
import { EventsComponent } from '../events/events.component';
@NgModule({
  declarations: [
    ServiceplanFormComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    MyDatePickerModule,
    DropDownListAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    ServiceplanFormRoutingModule,
    NgSelectModule,
    AccordionModule,
    SignaturePadModule,
    PDFExportModule,
    EventsModule
    
  ],
  exports:[ServiceplanFormComponent],
  providers: [ ]
})
export class ServiceplanFormModule { }
